import { SortDirection } from '@/common/types/sort';

export const ASC: SortDirection = 'asc';
export const DESC: SortDirection = 'desc';
